import { GridCellProps, GridColumnProps as ReactGridColumnProps } from '@progress/kendo-react-grid'

import { PermissionsEnum } from '../../../api/Identity/Types/PermissionsEnum'
import { NotificationContactDetailsPageKey } from '../../../api/Notifications/Types/NotificationContactDetailsDto'
import MoreButton from '../../../components/MoreButton/MoreButton'
import { usePermissions } from '../../../utils/permissionsValidator'
import { useAuditLogModal, useContactDetailsModal } from './ContactDetailsPage'

type ModalsProps = ReturnType<typeof useContactDetailsModal> & ReturnType<typeof useAuditLogModal>

const useRenderButtons = (props: ModalsProps) => {
  const { handleUpdateContactDetailsModalOpen, handleAuditLogOpen } = props

  const { hasPermission } = usePermissions()

  const renderButton = (gridCellProps: GridCellProps) => (
    <td>
      {hasPermission(PermissionsEnum.CanEditContactDetails) && (
        <MoreButton
          items={[
            {
              name: 'Edit',
              onClick: () => handleUpdateContactDetailsModalOpen(gridCellProps.dataItem),
            },
            {
              name: 'Audit Log',
              disabled: !hasPermission(PermissionsEnum.CanViewContactDetails),
              'data-test': 'audit-log',
              onClick: () => handleAuditLogOpen(gridCellProps.dataItem),
            },
          ]}
        />
      )}
    </td>
  )

  return {
    renderButton,
  }
}

export interface GridColumnProps extends ReactGridColumnProps {
  show: boolean
  width?: number
}

export const useContactDetailsColumns = (props: ModalsProps) => {
  const renderButtonProps = useRenderButtons(props)

  const contactDetailsColumns: GridColumnProps[] = [
    {
      title: 'Entity',
      field: NotificationContactDetailsPageKey.entity,
      show: true,
      className: 'table-columns__content',
      filter: 'text',
    },
    {
      title: 'Phone Number',
      field: NotificationContactDetailsPageKey.supportPhoneNumber,
      show: true,
      className: 'table-columns__content',
      filter: 'text',
    },
    {
      title: 'Email',
      field: NotificationContactDetailsPageKey.supportEmail,
      show: true,
      className: 'table-columns__content',
      filter: 'text',
    },
    {
      title: '',
      cell: renderButtonProps.renderButton,
      show: true,
      minResizableWidth: 50,
      width: 50,
    },
  ]

  return {
    contactDetailsColumns,
    ...renderButtonProps,
  }
}
